<!--
 * @Descripttion: 绑定手机号
 * @FilePath: /mall-wap-vue/src/views/login/binding/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-09 22:50:13
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-21 17:07:34
-->
<template>
  <div class="binding">
    <nav-bar @back="back" />
    <page-title title="绑定手机号" />
    <div class="content">
      <van-form ref="login" @submit="onSubmit">
        <!-- 手机号 -->
        <phone-field v-model="phone" @prefixChange="prefixChange" />
        <!-- 验证码 -->
        <code-field
          v-model="verifyCode"
          :phone="checkPhone"
          @senderCode="senderCode"
          @verifyCodeChange="verifyCodeChange"
        />
        <!-- 协议 -->
        <agreement v-model="agree" />
        <div class="actions">
          <!-- 登录按钮 -->
          <van-button
            block
            type="info"
            native-type="submit"
            class="login_submit"
            :disabled="disabledBtn"
          >
            绑定
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { verifyPhone } from "@/utils";
const NavBar = () => import("../components/NavBar");
const PageTitle = () => import("../components/PageTitle");
const PhoneField = () => import("../components/PhoneField");
const CodeField = () => import("../components/CodeField");
const Agreement = () => import("../components/Agreement");

export default {
  components: {
    NavBar,
    PageTitle,
    PhoneField,
    CodeField,
    Agreement
  },
  data() {
    return {
      phone: "",
      prefix: "+86",
      verifyCode: "",
      agree: "0",
      errorMsg: ""
    };
  },
  computed: {
    disabledBtn() {
      if (this.agree === "1" && verifyPhone(this.prefix, this.phone)) {
        if (!this.isPasswdLogin) {
          if (this.verifyCode.length === 6) {
            return false;
          }
        } else {
          if (this.password.length > 6) {
            return false;
          }
        }
      }
      return true;
    },
    checkPhone() {
      return verifyPhone(this.prefix, this.phone);
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    prefixChange(value) {
      this.prefix = value;
    },
    // 验证码
    verifyCodeChange(value) {
      this.verifyCode = value;
    },
    // 发送验证码
    senderCode(callback) {
      const data = {
        phone: this.phone,
        kind: "Login"
      };
      this.$store
        .dispatch("login/sendSms", {
          params: data
        })
        .then(() => {
          this.$toast("验证码已发送到您的手机");
          callback();
          // this.$router.push({
          //   path: this.redirect || "/",
          //   query: this.otherQuery
          // });
        })
        .catch(err => {
          this.errorMsg = err.message;
        });
    },
    onSubmit(values) {
      const { phone, verifyCode } = values;
      const params = {
        code: verifyCode,
        phone,
        kind: "Login"
      };
      this.$store
        .dispatch("login/phoneBinding", {
          params
        })
        .then(() => {
          this.$router.push({
            path: this.redirect || "/",
            query: this.otherQuery
          });
        })
        .catch(err => {
          this.errorMsg = err.message;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.binding {
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .content {
    margin: 72px 38px;
  }

  .actions {
    margin-top: 12px;

    .login_submit {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border: none;
      font-size: 16px;
      height: 48px;
      line-height: 48px;
    }
  }
}
</style>
